import React from 'react';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/designSystem/Table';
import { ExternalLinkIcon } from 'lucide-react';
import { Button } from '@/designSystem/Button';
import { RecentLookup } from '@/apps/runtimePropertyHealthScore/hooks/usePropertyLookup';

interface RecentPropertyLookupsProps {
  recentLookups: RecentLookup[];
  handleSelectRecentLookup: (recentLookup: RecentLookup) => void;
}

const RecentPropertyLookups: React.FC<RecentPropertyLookupsProps> = ({ recentLookups, handleSelectRecentLookup }) => {
  return recentLookups?.length ? (
    <div>
      <h2 className="text-xl font-semibold mb-4">Recent Searches</h2>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Property</TableHead>
            <TableHead>Location</TableHead>
            <TableHead>Last Checked</TableHead>
            <TableHead></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {recentLookups.map((lookup) => (
            <TableRow
              key={lookup.property_id}
              className="cursor-pointer hover:bg-muted/50"
              onClick={() => handleSelectRecentLookup(lookup)}
            >
              <TableCell>
                <div className="font-medium">{lookup.name}</div>
              </TableCell>
              <TableCell>{lookup.city}, {lookup.country_code}</TableCell>
              <TableCell>{lookup.lastChecked}</TableCell>
              <TableCell className="text-right">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(lookup.url, '_blank');
                  }}
                >
                  <ExternalLinkIcon className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  ) : null;
};

export default RecentPropertyLookups;